export type UserRightDraft = { id: number; right: string | null; intVal: number | null; stringVal: string | null; deleted?: boolean };
export type RightDefinition = { name: string; description: string; type: string; entity: string; optionGroup: string; selectionConstraint: string; visibilityConstraint: string; question?: string | null };

export const checkUserRights = (userRights: UserRightDraft[], allRights: Record<string, RightDefinition>, allowEmptyRights: boolean) => {

  const duplicateKeys = new Set();
  const duplicateGroups = new Set();
  const usedKeys = new Set();
  const usedGroups = new Set();
  const selectionConstraints: { rights: string[]; neededBy: string }[] = [];
  const validKeys = new Set();

  const issues = [];

  for (const right of userRights) {
    if (right.deleted) continue;
    if (!right.right) {
      issues.push("Leere Berechtigung gefunden.");
      continue;
    }
    if (!(right.right in allRights)) continue;
    const settings = allRights[right.right];
    if (settings.type === "Boolean" && right.intVal === null) {
      issues.push("Fehlender Wert bei der Berechtigung '" + settings.description + "'.");
    } else if (
      settings.type === "ManyToMany" &&
      (!right.stringVal || right.stringVal.split(",").filter((x) => !isNaN(parseInt(x)) && parseInt(x) > 0).length === 0)
    ) {
      issues.push("Fehlende zugehörige Einheiten bei der Berechtigung '" + settings.description + "'.");
    } else if (settings.type === "ManyToOne" && (!right.stringVal || isNaN(parseInt(right.stringVal)) || parseInt(right.stringVal) === 0)) {
      issues.push("Fehlende zugehörige Einheit bei der Berechtigung '" + settings.description + "'.");
    } else {
      validKeys.add(right.right);
    }

    if (usedKeys.has(right.right) && !duplicateKeys.has(right.right)) {
      issues.push("Berechtigung '" + settings.description + "' ist mehrfach vorhanden.");
      duplicateKeys.add(right.right);
    }

    if (settings.optionGroup.length > 0 && usedGroups.has(settings.optionGroup) && !duplicateGroups.has(settings.optionGroup)) {
      issues.push("Es darf nur eine Berechtigung der Art '" + settings.optionGroup + "' vorhanden sein.");
      duplicateGroups.add(settings.optionGroup);
    }

    if (settings.optionGroup.length > 0) usedGroups.add(settings.optionGroup);

    if (settings.selectionConstraint.length > 0) {
      selectionConstraints.push({
        rights: settings.selectionConstraint.split(",").filter((x) => x.length > 0),
        neededBy: settings.description,
      });
    }

    usedKeys.add(right.right);
  }

  if (usedKeys.size === 0 && !allowEmptyRights) {
    issues.push("Es wurde noch keine Berechtigung oder Rolle gewählt.");
  }

  for (const { rights, neededBy } of selectionConstraints) {
    let isFilled = false;
    for (const right of rights) {
      if (validKeys.has(right)) isFilled = true;
    }
    if (isFilled) continue;
    issues.push(
      "Die Berechtigung '" +
        neededBy +
        (rights.length === 1 ? "' erfordert die fehlende Berechtigung '" : "' erfordert eine dieser Berechtigungen: '") +
        rights.map((r) => allRights[r]?.description ?? r).join("', '") +
        "'.",
    );
  }
  return issues;
};
